import React from 'react'

import { LntModal } from '@app/components/base'

import { CopyArchivesListForm } from './CopyArchivesListForm'

import styles from './styles.module.scss'

import type { CopyArchivesItem } from '@app/api/routes/monitoringLists/types'
import type { CopyArchivesListModalProps } from './types'

export const CopyArchivesListModal: React.FC<CopyArchivesListModalProps> = props => {
  const { onSubmit, ...restProps } = props

  const handleSubmit = (data: CopyArchivesItem): void => onSubmit?.(data)

  return (
    <LntModal
      { ...restProps }
      className={ styles.copyListModal }
      footer={ null }
      destroyOnClose
    >
      <CopyArchivesListForm onSubmit={ handleSubmit } />
    </LntModal>
  )
}
